import { Injectable } from '@angular/core'
import { convertExtensionToMimeType } from './utils'

export type DownloadFileFormat = 'pdf' | 'docx' | 'csv' | 'json' | 'xlsx'

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  downloadData(data: any, fileName: string, format: DownloadFileFormat) {
    const blob = new Blob([data], { type: convertExtensionToMimeType(format) })
    const link = document.createElement('a')
    document.body.appendChild(link)
    link.download = fileName
    link.href = window.URL.createObjectURL(blob)
    link.click()
    // The file name carries the meeting name, which Sentry Replay would otherwise record off the lingering link.
    document.body.removeChild(link)
  }

  downloadFromUrl(url: string, fileName: string | null = null) {
    const a = document.createElement('a')
    a.href = url
    a.download = fileName ?? url.split('/').pop()!
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
